import { render, staticRenderFns } from "./ColegiadoEdit.vue?vue&type=template&id=dd4e7be0&scoped=true&"
import script from "./ColegiadoEdit.vue?vue&type=script&lang=js&"
export * from "./ColegiadoEdit.vue?vue&type=script&lang=js&"
import style0 from "./ColegiadoEdit.vue?vue&type=style&index=0&id=dd4e7be0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd4e7be0",
  null
  
)

export default component.exports